import { useSelector } from "react-redux";

export const ACTION_PREFIX = "@SET_STATE/";

/**
 * SetState: آپدیت state با merge اتوماتیک
 * @param {string} keyName - کلید state
 * @param {any|function} data - مقدار جدید یا callback(prevState) => newData
 * @param mergeData
 */
export function SetState(keyName, data, mergeData = false) {
    return (dispatch, getState) => {
        const prevState = getState()[keyName];

        let payload;

        // اگر قبلی object بود، merge انجام بده
        if (prevState && typeof prevState === "object" && !Array.isArray(prevState) && mergeData) {
            payload = typeof data === "function" ? { ...prevState, ...data(prevState) } : { ...prevState, ...data };
        }
        // اگر آرایه بود، concat کن
        else if (Array.isArray(prevState) && mergeData) {
            payload = typeof data === "function" ? [...prevState, ...data(prevState)] : Array.isArray(data) ? [...prevState, ...data] : [...prevState, data];
        }
        // برای primitive یا مقدار undefined/null، مقدار جدید جایگزین می‌شه
        else {
            payload = typeof data === "function" ? data(prevState) : data;
        }

        dispatch({
            type: `${ACTION_PREFIX}${keyName}`,
            payload
        });
    };
}

/**
 * GetState: خواندن state
 * - داخل کامپوننت React: مستقیم مقدار واقعی برمی‌گردونه
 * - خارج از کامپوننت: باید store.getState() یا getState از thunk استفاده بشه
 *
 * @param {string} keyName - کلید state
 * @param {any} def - مقدار پیش‌فرض
 */
export function GetState(keyName, def = null) {
    return useSelector(state => state?.[keyName] ?? def);
}
